import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Main from './components/Main';
import Promise from 'promise-polyfill';
import 'babel-polyfill';
import 'react-app-polyfill/ie11';

injectTapEventPlugin();
if (!window.Promise) {
  window.Promise = Promise;
}

render(
  <Router history={browserHistory}>
    <Route path='/(:category(/:search_by(/:options(/:size))))' component={Main} />
  </Router>
  , document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.jsx